import React from "react";

type ProviderWithProps = [React.ComponentType<any>, Record<string, any>?];

/**
 * Composes multiple React Context Providers into a single wrapper
 * to avoid deeply nested JSX (pyramid of doom).
 *
 * Usage:
 *   const Providers = composeProviders([
 *     [ThemeProvider, { theme }],
 *     [AuthProvider, { user }],
 *     [LanguageProvider],
 *   ]);
 *   return <Providers>{children}</Providers>;
 */
export function composeProviders(providers: ProviderWithProps[]): React.FC<{ children: React.ReactNode }> {
  return function ComposedProviders({ children }) {
    return providers.reduceRight<React.ReactElement>(
      (acc, [Provider, props = {}]) => <Provider {...props}>{acc}</Provider>,
      children as React.ReactElement,
    );
  };
}
